// NATIVE 
import React, { useEffect, useState } from 'react';


// INSTALLED 
import { useSelector } from 'react-redux';
import { styled } from '@mui/material/styles';
import { Divider, Grid, TextField } from '@mui/material';
import TextAreaField from '../../formFields/TextAreaField';
import AutocompleteField from '../../formFields/autocompleteField';


// CUSTOM 
import InputField from '../../formFields/InputField';
import CheckboxField from '../../formFields/checkBoxField';
import InputNumeric from '../../formFields/InputNumeric';
import DatePickerField from '../../formFields/datePickerField';
import HourPicker from '../../formFields/HourPicker';
import { formatDateToYmd } from '../../../commons/utils';





export const DetalleNovedadTurno = (props:any) => {



    const { novedades_turno } = useSelector((state: any) => state.novedadesTurno);


    const { formField: {
        colaborador,
        responsable,
        tipoNovedad,
        fechaNovedad,
        horaNovedad,
        description
      }
    } = props;  

    console.log('novedades_turno ',novedades_turno)
     useEffect(() => {
       console.log('novedades_turno ',novedades_turno)
     }, [novedades_turno])
     
            


    const Div = styled('div')(({ theme }) => ({
        ...theme.typography.button,
        backgroundColor: 'wheat',
        padding: theme.spacing(8),
        textAlign: 'center'
    }));


    

  return (
    <div>
        
        <div>
            <Grid container>

                {/* ************ */}
                <Grid item xs={6} sx={{ padding: 2 }}>
                    <TextField
                        fullWidth
                        name={novedades_turno.empleado.name+ ' '+novedades_turno.empleado.last_name}
                        label={'Colaborador'}
                        defaultValue={novedades_turno.empleado.name+ ' '+novedades_turno.empleado.last_name}
                        InputProps={{
                        readOnly: true,
                        }}
                    />
                </Grid>
                <Grid item xs={6} sx={{ padding: 2 }}>
                    <TextField
                        fullWidth
                        name={novedades_turno.responsable.name+ ' '+novedades_turno.responsable.last_name}
                        label={'Responsable'}
                        defaultValue={novedades_turno.responsable.name+ ' '+novedades_turno.responsable.last_name}
                        InputProps={{
                        readOnly: true,
                        }}
                    />
                </Grid>
                 {/* ************ */}



                {/* ************ */}
                <Grid item xs={6} sx={{ padding: 2 }}>
                    <TextField
                        fullWidth
                        name={novedades_turno.tipoNovedad.name}
                        label={'Tipo novedad'}
                        defaultValue={novedades_turno.tipoNovedad.name}
                        InputProps={{
                        readOnly: true,
                        }}
                    />
                </Grid>
                <Grid item xs={3} sx={{ padding: 2 }}>
                    <TextField
                        fullWidth
                        name={novedades_turno.fecha_novedad}
                        label={'Fecha novedad'}
                        defaultValue={ formatDateToYmd(novedades_turno.fecha_novedad) }
                        InputProps={{
                        readOnly: true,
                        }}
                    />
                    
                </Grid>
                <Grid item xs={3} sx={{ padding: 2 }}>
                    <TextField
                        fullWidth
                        name={novedades_turno.hora_novedad}
                        label={'Fecha novedad'}
                        defaultValue={novedades_turno.hora_novedad}
                        InputProps={{
                          readOnly: true,
                        }}
                    />
                    
                </Grid>
                 {/* ************ */}
                
                
                {/* ************ */}
                <Grid item xs={12} sx={{ padding: 2 }}>
                    <TextAreaField 
                        name={novedades_turno.descripcion}
                        label={'Descripcion'}
                        defaultValue={novedades_turno.descripcion}
                        variant="outlined" 
                        fullWidth
                        InputProps={{
                            readOnly: true,
                        }}
                    />
                </Grid>
                {/* ************ */}
                
                

                <Divider/>


                
                
                    

            </Grid>
        </div>
        
    </div>
  )
}

